import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import SearchBar from 'tuc-webui-base/components/SearchBar';
import { useRowNumber } from 'tuc-webui-base/components/TableViewComponent';
import { TABLE_PANEL_TYPE } from 'grb-webui/ComponentTypes';
import { withStoreData } from 'grb-webui/store';
import AppMainPage, { FIT_TO_PAGE_VARIANT } from '../../components/AppMainPage';
import withJobs from './withJobs';
import DefaultNonAggregatedJobPanel from './NonAggregatedJobPanel';
import './JobsContainer.scss';

export default (options = {}) => {
  const {
    jobsEntity,
    entities,
    jobType,
  } = options;
  const useNonAggregate = options.jobService.useNonAggregate();
  const NonAggregatedJobPanel = options.NonAggregatedJobPanel
    || DefaultNonAggregatedJobPanel(options);

  const JobQueuePage = (props) => {
    const { [jobsEntity]: jobs, search, onSearchChange, configuration, ...rest } = props;
    const [TablePanel] = useState(() => props.viewService.getComponent(TABLE_PANEL_TYPE));
    const jobsCount = useRowNumber(jobs, false, false /* Server filtering */);

    // Aggregate queue
    const [aggregateQueue, setAggregateQueue] = useState(() => {
      return useNonAggregate && window.localStorage.getItem('aggregate-queue') !== 'false';
    });

    const handleAggregateQueue = useCallback((event) => {
      const agg = event.target.checked;
      window.localStorage.setItem('aggregate-queue', agg ? 'true' : 'false');
      setAggregateQueue(agg);
    }, []);

    return (
      <AppMainPage
        route={props.route}
        variant={FIT_TO_PAGE_VARIANT}
        TrailingBar={(
          <React.Fragment>
            <SearchBar
              {...props}
              placeholder="Search jobs..."
              value={search}
              onChange={onSearchChange}
            />
            {useNonAggregate && (
              <FormControlLabel
                control={(
                  <Switch
                    checked={aggregateQueue}
                    onChange={handleAggregateQueue}
                    name="aggregate-jobs-check"
                    color="primary"
                    id="aggregate-jobs-check"
                  />
                )}
                label="Aggregate queue"
                className="grb-gutter-left"
              />
            )}
          </React.Fragment>
        )}
        className={classnames('grb-jobs-page', `grb-${jobType}-page`)}
        rowCount={jobsCount}
        help={configuration && configuration.help}
      >
        <div className={classnames('grb-jobs-table-panel', 'grb-fullpage', 'MuiPaper-elevation4')}>
          {(aggregateQueue || !useNonAggregate || (jobs.length === 0)) ? (
            <TablePanel
              {...rest}
              {...(rest.components ? rest.components[0] : rest.component)}
              jobs={jobs}
              jobsCount={jobsCount}
            />
          ) : (
            <NonAggregatedJobPanel
              {...rest}
              {...rest.components[1]}
            />
          )}
        </div>
      </AppMainPage>
    );
  };

  JobQueuePage.propTypes = {
    [jobsEntity]: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    viewService: PropTypes.shape({
      onError: PropTypes.func,
      getComponent: PropTypes.func,
    }).isRequired,
    route: PropTypes.shape({}).isRequired,
    component: PropTypes.shape({}),
    components: PropTypes.arrayOf(PropTypes.shape({})),
    search: PropTypes.string,
    onSearchChange: PropTypes.func,
    configuration: PropTypes.shape({
      help: PropTypes.shape({}),
    }),
  };

  JobQueuePage.defaultProps = {
    component: undefined,
    components: undefined,
    search: undefined,
    onSearchChange: undefined,
    configuration: undefined,
  };

  return withJobs(
    withStoreData(JobQueuePage, {
      entities,
    }),
    options,
  );
};
